import { axiosInstance } from '@/modules/shared/lib/axios'
import { RenameCompanyGroupRequest } from './types'

type Props = {
  companyId: string
  payload: RenameCompanyGroupRequest
}

export function renameCompanyGroup({ companyId, payload }: Props) {
  return axiosInstance.post(
    `/config-api/${companyId}/configuration/admin/companies/renameGroup`,
    payload
  )
}
